import { useSearchParams } from "react-router";
import { useNavigate } from "react-router";
import Signup from "@/app/auth/signup/signup.page";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSignupInviteInit } from "@/app/auth/signup/signup.hooks";
import { useAppSelector } from "@/lib/store";
import { AcceptInvite } from "@/app/auth/signup/signup.components/accept-invite.tsx";

export default function SignupInvitePage() {
    const [sp] = useSearchParams();
    const token = sp.get("token");
    const { inviteInitLoading, inviteInitError } = useSignupInviteInit(token);
    const { inviteToken, inviteKind, inviterName, inviteeName, email } = useAppSelector((state) => state.signupWizard);
    const signedIn = useAppSelector((state) => state.auth.user !== null);
    const signupPending = useAppSelector((state) => state.auth.signupPending);
    const navigate = useNavigate();

    if (inviteInitLoading) {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
        );
    }

    if (inviteInitError) {
        return (
            <div className="flex h-screen w-screen flex-col items-center justify-center space-y-4 text-center">
                <p className="text-lg font-medium">{inviteInitError}</p>
                <Button onClick={() => navigate(signedIn ? "/" : "/signup")}>{signedIn ? "Go to Home" : "Back to sign-up"}</Button>
            </div>
        );
    }

    if ((signedIn || signupPending) && token && inviteToken === token && inviteKind && email) {
        return <AcceptInvite token={token} kind={inviteKind} inviterName={inviterName} email={email} inviteeName={inviteeName} newPerson={!signedIn} />;
    }

    return <Signup />;
}
